
import RecommendationSection from '@recommendation/components/RecommendationSection/RecommendationSection.vue'
import { PRODUCT_SOURCE_TYPE } from '@tracking'

import translations from './RecommendationCrossSell.translations'

export default {
  components: {
    RecommendationSection,
  },
  props: {
    listingId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    translations: () => translations,
    trackingList: () => PRODUCT_SOURCE_TYPE.CROSS_SELL_MODAL,
    scopeId() {
      return String(this.listingId)
    },
    // TODO: [SR-2036] Clean AB test
    title() {
      const abtest =
        this.$store.getters['experiments/getExperiments'].crossSellStrategy
      switch (abtest) {
        case 'crossSellProtectionOnly':
          return this.$t(this.translations.titleAccessories)
        case 'crossSellMixProducts':
        case 'noVariation':
        default:
          return this.$t(this.translations.title)
      }
    },
    // TODO: [SR-2036] Clean AB test
    category() {
      const abtest =
        this.$store.getters['experiments/getExperiments'].crossSellStrategy
      switch (abtest) {
        case 'crossSellProtectionOnly':
          return 'crossSellOneBrandNew'
        case 'crossSellMixProducts':
        case 'noVariation':
        default:
          return 'crossSellOne'
      }
    },
  },
}
